import { render, staticRenderFns } from "./ProctoredCertificatedTest.vue?vue&type=template&id=405a9e54&"
import script from "./ProctoredCertificatedTest.vue?vue&type=script&lang=js&"
export * from "./ProctoredCertificatedTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports